export function sanitizeKey(key: unknown[] | readonly unknown[]) {
  return (key as unknown[]).filter(
    (key) => key !== undefined && key !== null && key !== ""
  ) as readonly unknown[];
}
